module.exports = __webpack_public_path__ + "static/media/magnet.ecf4a5d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/magnet.svg
// module id = 333
// module chunks = 0